import { render, staticRenderFns } from "./StartCountingWithTextareaPopup.vue?vue&type=template&id=2eda2d48"
import script from "./StartCountingWithTextareaPopup.vue?vue&type=script&lang=js"
export * from "./StartCountingWithTextareaPopup.vue?vue&type=script&lang=js"
import style0 from "./StartCountingWithTextareaPopup.vue?vue&type=style&index=0&id=2eda2d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports